import { Typography } from "@mui/material"
import { If } from "lib/@components/switch"

export function TitleNewOrRemoved({ payload }) {
    const taskOrHeader = payload?.isHeader ? "Header" : "Task"
    const isAddedOrDeleted = payload?.subHeader
    const taskTitle = payload?.taskTitle

    return (
        <If truthy={!!isAddedOrDeleted}>
            <Typography variant={"body2"}>
                {taskOrHeader}: "{taskTitle}" {isAddedOrDeleted}
            </Typography>
        </If>
    )
}
